(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["TableRun"] = factory();
	else
		root["TableRun"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(4)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(6),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-60462ba5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var SORTABLE_COLUMN_EVENT = 'on-column-sortable';

function onColumnSortable(column) {
	this.$emit(SORTABLE_COLUMN_EVENT, column);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	methods: {
		onColumnSortable: onColumnSortable
	},
	name: 'table-column-item',
	props: {
		column: {
			type: Object,
			required: true
		},
		onCloumnSortable: {
			type: Function
		}
	}
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableColumnItem__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableColumnItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TableColumnItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SEARCH_EVENT = 'on-search-event';
var DELETE_ROWS_EVENT = 'on-delete-selected';
var DELETE_ROW_EVENT = 'on-delete-event';
var EXPORT_ROWS_EVENT = 'on-export-selected';
var GO_TO_PHOTOS_EVENT = 'go-to-photos-page';
var GO_TO_EDIT_EVENT = 'go-to-edit-page';
var CHANGE_STATE_EVENT = 'on-change-state';
var ON_SORTABLE_EVENT = 'on-sortable-event';
var OPEN_DETAIL_EVENT = 'on-open-detail';
var ON_DRAG_EVENT = 'on-drag-event';
var ON_DRAG_ENTER = 'on-drag-enter';
var ON_DRAG_LEAVE = 'on-drag-leave';
var ON_DROP_EVENT = 'on-drop-event';
var PREFIX_TABLE_LS = 'tablerun::';

var components = {
	TableColumnItem: __WEBPACK_IMPORTED_MODULE_0__TableColumnItem___default.a
};

function bodyRows() {
	var _this = this;

	var newRows = this.rows.map(function (row) {
		var newRow = row;
		newRow.isSelected = _this.checkAll;
		return newRow;
	});
	return newRows;
}

function data() {
	return {
		checkAll: false,
		colspan: null,
		open: false,
		search: ''
	};
}

function disabledAllRows() {
	var _this2 = this;

	return this.bodyRows.every(function (row) {
		return !row[_this2.disabledProp];
	});
}

function mounted() {
	if (this.localStorage) {
		var searchFromLocalStorage = window.localStorage.getItem(PREFIX_TABLE_LS + 'search');
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}

	if (this.includeDelete && this.includeExportToExcel) {
		this.colspan = 3;
	} else if (this.includeDelete || this.includeExportToExcel) {
		this.colspan = 2;
	} else {
		this.colspan = null;
	}
}

function columnSortable(column) {
	this.$emit(ON_SORTABLE_EVENT, column);
}

function onChangeState(row) {
	this.$emit(CHANGE_STATE_EVENT, row);
}

function onDeleteRows() {
	var rowsSelected = this.bodyRows.filter(function (row) {
		return row.isSelected;
	});
	if (rowsSelected.length > 0) {
		if (confirm('Are you sure?')) {
			this.$emit(DELETE_ROWS_EVENT, rowsSelected);
		}
	} else {
		alert('You must select one row at least');
	}
}

function openDetail() {
	this.$emit(OPEN_DETAIL_EVENT);
}

function onExportRows() {
	var rowsSelected = this.bodyRows.filter(function (row) {
		return row.isSelected;
	});
	if (rowsSelected.length > 0) {
		if (confirm('Are you sure?')) {
			this.$emit(EXPORT_ROWS_EVENT, rowsSelected);
		}
	} else {
		alert('You must select one row at least');
	}
}

function deleteRow(row) {
	if (confirm('Are you sure?')) {
		this.$emit(DELETE_ROW_EVENT, row);
	}
}

function goToEditPage(row, event) {
	this.$emit(GO_TO_EDIT_EVENT, row, event);
}

function goToPhotosPage(row) {
	this.$emit(GO_TO_PHOTOS_EVENT, row);
}

function searchRows($event) {
	var keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	window.localStorage.setItem(PREFIX_TABLE_LS + 'search', this.search);
	this.$emit(SEARCH_EVENT, this.search);
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: components,
	computed: {
		bodyRows: bodyRows,
		disabledAllRows: disabledAllRows
	},
	name: 'table-run',
	data: data,
	methods: {
		columnSortable: columnSortable,
		deleteRow: deleteRow,
		goToPhotosPage: goToPhotosPage,
		goToEditPage: goToEditPage,
		onChangeState: onChangeState,
		onDeleteRows: onDeleteRows,
		onDrag: onDrag,
		onDragEnter: onDragEnter,
		onDragLeave: onDragLeave,
		onDrop: onDrop,
		onExportRows: onExportRows,
		openDetail: openDetail,
		searchRows: searchRows
	},
	mounted: mounted,
	props: {
		columns: {
			type: Array,
			required: true
		},
		includeDelete: {
			type: Boolean,
			default: true
		},
		includeExportToExcel: {
			type: Boolean,
			default: true
		},
		includeSearch: {
			type: Boolean,
			default: true
		},
		includeOptions: {
			type: Boolean,
			default: false
		},
		includeState: {
			type: Boolean,
			default: false
		},
		includeImages: {
			type: Boolean,
			default: false
		},
		includeSwitch: {
			type: Boolean,
			default: false
		},
		includeInfo: {
			type: Boolean,
			default: false
		},
		includeSettings: {
			type: Boolean,
			default: false
		},
		includeDeleteSingle: {
			type: Boolean,
			default: false
		},
		localStorage: {
			type: Boolean,
			default: false
		},
		onDeleteSelected: {
			type: Function
		},
		onSortableEvent: {
			type: Function
		},
		rows: {
			type: Array,
			required: true
		},
		selectable: {
			type: Boolean,
			default: true
		},
		selectAll: {
			type: Boolean,
			default: false
		},
		statePropertyName: {
			type: String,
			default: 'state_id'
		},
		switchValue: {
			type: String,
			default: 'flagactive'
		},
		keyValue: {
			type: String,
			default: 'id'
		},
		disabledProp: {
			default: 'flagUse',
			type: String
		},
		optionButtons: {
			default: function _default() {
				return [];
			},
			type: Array
		}
	}
});

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(2),
  /* template */
  __webpack_require__(7),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table-list",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [(_vm.selectable) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.disabledAllRows
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAll) ? _vm._i(_vm.checkAll, null) > -1 : (_vm.checkAll)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAll = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return _c("table-column-item", {
      key: column.id,
      tag: "th",
      attrs: {
        "column": column
      },
      on: {
        "on-column-sortable": function($event) {
          _vm.columnSortable(column)
        }
      }
    })
  }), _vm._v(" "), (_vm.includeDelete) ? _c('th', [_c('a', {
    on: {
      "click": _vm.onDeleteRows
    }
  }, [_c('i', {
    staticClass: "icon-delete material-icons icon"
  }, [_vm._v("delete")])])]) : _vm._e(), _vm._v(" "), (_vm.includeExportToExcel) ? _c('th', [_c('a', {
    on: {
      "click": _vm.onExportRows
    }
  }, [_c('i', {
    staticClass: "icon-export material-icons icon"
  }, [_vm._v("insert_drive_file")])])]) : _vm._e(), _vm._v(" "), (_vm.includeSearch) ? _c('th', [_c('div', {
    staticClass: "input-group__input search-input right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchRows($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.searchRows($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "material-icons icon input-group__append-icon"
  }, [_vm._v("search")])])]) : _vm._e(), _vm._v(" "), (_vm.includeOptions && !_vm.includeDelete && !_vm.includeExportToExcel && !_vm.includeSearch) ? _c('th', [_vm._v("\n\t\t\t\t \n\t\t\t")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.bodyRows), function(row) {
    return _c('tr', {
      key: row[_vm.keyValue],
      attrs: {
        "draggable": "true",
        "droppable": "true"
      },
      on: {
        "dragover": function($event) {
          $event.preventDefault();
        },
        "dragenter": function($event) {
          _vm.onDragEnter(row)
        },
        "dragleave": function($event) {
          _vm.onDragLeave(row)
        },
        "drop": function($event) {
          _vm.onDrop(row)
        },
        "drag": function($event) {
          _vm.onDrag(row)
        }
      }
    }, [(_vm.selectable) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.isSelected),
        expression: "row.isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": row[_vm.disabledProp]
      },
      domProps: {
        "checked": Array.isArray(row.isSelected) ? _vm._i(row.isSelected, null) > -1 : (row.isSelected)
      },
      on: {
        "__c": function($event) {
          var $$a = row.isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (row.isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (row.isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            row.isSelected = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm._t("rows", null, {
      row: row
    }), _vm._v(" "), (_vm.includeDelete && !_vm.includeOptions) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.includeExportToExcel && !_vm.includeOptions) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.includeSearch && !_vm.includeOptions) ? _c('td', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.includeOptions) ? _c('td', {
      staticClass: "options-column",
      attrs: {
        "colspan": _vm.colspan
      }
    }, [_vm._t("options"), _vm._v(" "), (_vm.includeState) ? _c('span', {
      staticClass: "options-item"
    }, [_c('span', {
      class: ("circle-state state-" + (row[_vm.statePropertyName]))
    })]) : _vm._e(), _vm._v(" "), (_vm.includeImages) ? _c('span', {
      staticClass: "options-item"
    }, [_c('a', {
      staticClass: "link-to",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToPhotosPage(row)
        }
      }
    }, [_c('i', {
      staticClass: "image-icon material-icons icon"
    }, [_vm._v("collections")])])]) : _vm._e(), _vm._v(" "), (_vm.includeSwitch) ? _c('span', {
      staticClass: "options-item"
    }, [_c('label', {
      staticClass: "switch",
      attrs: {
        "for": ("inptSwitch-" + (row[_vm.keyValue]))
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row[_vm.switchValue]),
        expression: "row[switchValue]"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("inptSwitch-" + (row[_vm.keyValue])),
        "true-value": 1,
        "false-value": 0
      },
      domProps: {
        "checked": Array.isArray(row[_vm.switchValue]) ? _vm._i(row[_vm.switchValue], null) > -1 : _vm._q(row[_vm.switchValue], 1)
      },
      on: {
        "click": function($event) {
          _vm.onChangeState(row)
        },
        "__c": function($event) {
          var $$a = row[_vm.switchValue],
            $$el = $event.target,
            $$c = $$el.checked ? (1) : (0);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (row[_vm.switchValue] = $$a.concat($$v))
            } else {
              $$i > -1 && (row[_vm.switchValue] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(row, _vm.switchValue, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slider round"
    })])]) : _vm._e(), _vm._v(" "), (_vm.includeInfo) ? _c('span', {
      staticClass: "options-item"
    }, [_c('button', {
      staticClass: "button-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.openDetail
      }
    }, [_c('i', {
      staticClass: "info-icon material-icons icon"
    }, [_vm._v("info")])])]) : _vm._e(), _vm._v(" "), (_vm.includeSettings) ? _c('span', {
      staticClass: "options-item"
    }, [_c('a', {
      staticClass: "link-to",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToEditPage(row, $event)
        }
      }
    }, [_c('i', {
      staticClass: "settings-icon material-icons icon"
    }, [_vm._v("settings")])])]) : _vm._e(), _vm._v(" "), (_vm.includeDeleteSingle) ? _c('span', {
      staticClass: "options-item"
    }, [_c('button', {
      staticClass: "button-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteRow(row)
        }
      }
    }, [_c('i', {
      staticClass: "info-icon material-icons icon"
    }, [_vm._v("delete")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.optionButtons), function(btn) {
      return _c('span', {
        key: btn.id,
        staticClass: "options-item"
      }, [_c('button', {
        staticClass: "button-info",
        attrs: {
          "title": btn.title,
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.$emit('custom-button', {
              btn: btn,
              row: row
            })
          }
        }
      }, [_c('i', {
        staticClass: "info-icon material-icons icon"
      }, [_vm._v(_vm._s(btn.icon))])])])
    })], 2) : _vm._e()], 2)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "id": 'column-' + _vm.column.id
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.column.name) + "\n\t"), (_vm.column.isSortable) ? _c('button', {
    staticClass: "sortable-button",
    on: {
      "click": function($event) {
        _vm.onColumnSortable(_vm.column)
      }
    }
  }, [(_vm.column.isSortable.down) ? _c('i', {
    staticClass: "sortable-icon material-icons icon"
  }, [_vm._v("arrow_drop_down")]) : _vm._e(), _vm._v(" "), (_vm.column.isSortable.up) ? _c('i', {
    staticClass: "sortable-icon material-icons icon"
  }, [_vm._v("arrow_drop_up")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// TableRun.js